import React, { useEffect } from 'react';
import Layout from '../layout/Layout';
import { usePageContent } from '../../context/ContentContext';

const ModernSlaveryPage = () => {
    const { t, g } = usePageContent('modernSlavery');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Layout>
            {/* Hero Section */}
            <section className="relative h-[70vh] overflow-hidden">
                <img
                    src={t('hero.image')}
                    alt={t('hero.title')}
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60 flex items-center justify-center">
                    <h1 className="font-poppins font-light text-h1 text-white text-center px-4">
                        {t('hero.title')}
                    </h1>
                </div>
            </section>

            {/* Introduction */}
            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto">
                        <h2 className="font-poppins font-light text-h2 mb-8 text-primary-dark-red text-center">
                            {t('commitment.title')}
                        </h2>
                        {t('commitment.paragraphs').map((paragraph, index) => (
                            <p key={index} className="font-poppins font-normal text-body mb-6">
                                {paragraph}
                            </p>
                        ))}
                    </div>
                </div>
            </section>

            {/* Supply Chain */}
            <section className="py-20 bg-background-cool-blue">
                <div className="container mx-auto px-4">
                    <h2 className="font-poppins font-light text-h2 text-center mb-12 text-primary-dark-red">
                        {t('supplyChain.title')}
                    </h2>

                    <div className="max-w-4xl mx-auto">
                        <p className="font-poppins font-normal text-body mb-8 text-center">
                            {t('supplyChain.intro')}
                        </p>

                        <div className="bg-white p-8 rounded-lg shadow-sm mb-8">
                            <h3 className="font-poppins font-semibold text-h3 mb-4 text-primary-red">{t('supplyChain.partnersTitle')}</h3>
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                {t('supplyChain.partners').map((partner, index) => (
                                    <div key={index} className="bg-accent-powder-green p-4 rounded-lg text-center">
                                        <span className="font-poppins font-semibold text-body">{partner}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="bg-white p-8 rounded-lg shadow-sm">
                            <h3 className="font-poppins font-semibold text-h3 mb-4 text-primary-red">{t('supplyChain.localTitle')}</h3>
                            <p className="font-poppins font-normal text-body text-gray-700">
                                {t('supplyChain.localBody')}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Certifications & Standards */}
            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    <h2 className="font-poppins font-light text-h2 text-center mb-12 text-primary-dark-red">
                        {t('certifications.title')}
                    </h2>

                    <div className="max-w-4xl mx-auto">
                        <p className="font-poppins font-normal text-body mb-8 text-center">
                            {t('certifications.intro')}
                        </p>

                        <div className="grid md:grid-cols-2 gap-6">
                            {t('certifications.items').map((item, index) => (
                                <div key={index} className="bg-accent-powder-green p-6 rounded-lg">
                                    <h3 className="font-poppins font-semibold text-h3 mb-3 text-primary-red">{item.title}</h3>
                                    <p className="font-poppins font-normal text-sub text-gray-700">
                                        {item.body}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Policies */}
            <section className="py-20 bg-background-cool-blue">
                <div className="container mx-auto px-4">
                    <h2 className="font-poppins font-light text-h2 text-center mb-12 text-primary-dark-red">
                        {t('policies.title')}
                    </h2>

                    <div className="max-w-4xl mx-auto">
                        <div className="bg-white p-8 rounded-lg shadow-sm">
                            <ul className="font-poppins font-normal text-body text-gray-700 space-y-4">
                                {t('policies.items').map((item, index) => (
                                    <li key={index} className="flex items-start">
                                        <span className="text-primary-red mr-3 mt-1">•</span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* Due Diligence */}
            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    <h2 className="font-poppins font-light text-h2 text-center mb-12 text-primary-dark-red">
                        {t('dueDiligence.title')}
                    </h2>

                    <div className="max-w-4xl mx-auto">
                        <div className="grid md:grid-cols-2 gap-8">
                            {t('dueDiligence.items').map((item, index) => (
                                <div key={index} className="bg-accent-powder-green p-6 rounded-lg">
                                    <h3 className="font-poppins font-semibold text-h3 mb-4 text-primary-red">{item.title}</h3>
                                    <p className="font-poppins font-normal text-body text-gray-700">
                                        {item.body}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Call to Action */}
            <section className="py-20 bg-primary-dark-red text-white">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="font-poppins font-light text-h2 mb-6">
                        {t('cta.title')}
                    </h2>
                    <p className="font-poppins font-normal text-body max-w-2xl mx-auto mb-10">
                        {t('cta.body')}
                    </p>
                    <a
                        href={`mailto:${g('contact.email')}`}
                        className="inline-block px-8 py-4 bg-primary-red text-white hover:bg-pink-600 transition-colors duration-300 font-poppins font-semibold text-h3 rounded-lg"
                    >
                        {t('cta.buttonText')}
                    </a>
                </div>
            </section>
        </Layout>
    );
};

export default ModernSlaveryPage;
